// A partner may give an optional, learner-facing reason when rejecting an
// access request (report 10, FLOW-15). reject_partner_access_request appends
// it to partner_transactions.notes as a final "Rejection reason: …" line, after
// the learner's own note. Only that line is ever shown back to the learner.

const REJECTION_REASON_PREFIX = "Rejection reason: ";

export const REJECTION_REASON_MAX_LENGTH = 500;

export const getRejectionReason = (notes) => {
  const text = String(notes ?? "");
  const index = text.lastIndexOf(REJECTION_REASON_PREFIX);
  if (index < 0 || (index > 0 && text[index - 1] !== "\n")) return null;
  return text.slice(index + REJECTION_REASON_PREFIX.length).trim() || null;
};

// Blank or whitespace-only input means "no reason" (the RPC stores nothing).
export const normalizeRejectionReason = (reason) =>
  String(reason ?? "")
    .trim()
    .slice(0, REJECTION_REASON_MAX_LENGTH) || null;
